// Standardized copy constants for cross-section compatibility
export const COPY_KEYS = {
  // Common headings used across sections
  HEADINGS: {
    TIMESTAMP: "timestamp",
    SITE: "site",
    SITES: "sites",
    CUSTOMER: "customer",
    ASSET: "asset",
    ASSET_NAME: "asset_name",
    ASSETS: "assets",
    LOCATION: "location",
    TYPE: "type",
    STATUS: "status",
    NAME: "name",
    ACTIONS: "actions",
    USAGE: "usage",
    AMOUNT: "amount",
    RUN_DRY: "run_dry",
    REFUEL_NEEDED: "refuel_needed",
    TIME_TO_DEPLETION: "time_to_depletion",
    NOTE: "note",
    CURRENT_ORDER: "current_order",
    HYDROGEN_ORDERED: "hydrogen_ordered",
    HYDROGEN_CONSUMED: "hydrogen_consumed",
    HYDROGEN_RETURNED: "hydrogen_returned",
    HYDROGEN_RETURNED_PER_FULFILLMENT: "hydrogen_returned_per_fulfillment",
    AVERAGE_ORDER: "average_order",
    // Orders/Deployments specific
    ORDER: "order",
    ORDERS: "orders",
    ORDER_ID: "order_id",
    ORDER_QUANTITY: "order_quantity",
    ORDER_START: "order_start",
    ORDER_END: "order_end",
    ACTIVITY: "activity",
    ACTIVITIES: "activities",
    ACTIVITY_NAME: "activity_name",
    ACTIVITY_TYPE: "activity_type",
    QUANTITY: "quantity",
    START_DATE: "start_date",
    END_DATE: "end_date",
    INFORMATION: "information",
    DETAILS: "details",
    SCHEDULED_QUANTITY: "scheduled_quantity",
    ACTUAL_QUANTITY: "actual_quantity",
    QUANTITY_FULFILLED: "quantity_fulfilled",
    QUANTITY_CONSUMED: "quantity_consumed",
    QUANTITY_DELIVERED: "quantity_delivered",
    QUANTITY_PLANNED: "quantity_planned",
    QUANTITY_ORDERED: "quantity_ordered",
    COMPLETED: "completed",
    SCHEDULED: "scheduled",
    IN_PROGRESS: "in_progress",
    STATUS_HISTORY: "status_history",
    SOURCE: "source",
    DESTINATION: "destination",
    // Dialog/Modal text
    PERFORM_ACTIONS: "perform_actions",
    EDIT_PREFIX: "edit_prefix",
    // Calendar
    CALENDAR: "calendar",
    // Filling specific
    FILL_SITE: "fill_site",
    FILL_SITES: "fill_sites",
    FILL_ACTIVITIES: "fill_activities",
    FILLS: "fills",
    SELECT_FILL_SITE: "select_fill_site",
    LEVEL: "level",
  },

  // Common button actions
  BUTTONS: {
    CREATE: "create",
    CREATE_SITE: "createSite",
    EDIT: "edit",
    DELETE: "delete",
    DELETE_ACTIVITY: "delete_activity",
    VIEW: "view",
    MONITOR: "monitor",
    LOG: "log",
    FILTER: "filter",
    ARCHIVE: "archive",
    COLLAPSE: "collapse",
    EXPAND: "expand",
    MANAGE: "manage",
    MANAGE_FULFILMENTS: "manage_fulfilments",
    SCHEDULE: "schedule",
    START: "start",
    START_ACTIVITY: "start_activity",
    COMPLETE: "complete",
    COMPLETE_ACTIVITY: "complete_activity",
    BILL: "bill",
    EDIT_DETAILS: "edit_details",
    EDIT_ID: "edit_id",
    SAVE: "save",
    CANCEL: "cancel",
    EDIT_DATES: "edit_dates",
  },

  // Common routes/pages
  ROUTES: {
    OVERVIEW: "",
    DETAILS: "details",
    ASSETS: "assets",
    SITES: "sites",
    USAGE: "usage",
    MONITORING: "monitoring",
    HISTORY: "history",
    FORECAST: "forecast",
  },

  // Toast messages
  MESSAGES: {
    CREATED: "created",
    UPDATED: "updated",
    DELETED: "deleted",
    ARCHIVED: "archived",
    SCHEDULED: "scheduled",
    STARTED: "started",
    COMPLETED: "completed",
    BILLED: "billed",
    FAILED: "failed",
    SUCCESS: "success",
    ERROR: "error",
    LOADING: "loading",
    SUCCESSFULLY_CREATED: "successfully_created",
    SUCCESSFULLY_UPDATED: "successfully_updated",
    SUCCESSFULLY_DELETED: "successfully_deleted",
    SUCCESSFULLY_ARCHIVED: "successfully_archived",
    HAS_BEEN_SUCCESSFULLY: "has_been_successfully",
    CREATION_FAILED: "creation_failed",
    UPDATE_FAILED: "update_failed",
    DELETION_FAILED: "deletion_failed",
    VALIDATION_ERROR: "validation_error",
    UNEXPECTED_ERROR: "unexpected_error",
    ASSETS_UNAVAILABLE: "assets_unavailable",
    END_DATE_BEFORE_START_DATE: "end_date_before_start_date",
    INVALID_DATE_FORMAT: "invalid_date_format",
    PLEASE_PROVIDE_NAME: "please_provide_name",
    PLEASE_SELECT_TYPE: "please_select_type",
    VOLUME_GREATER_THAN_ZERO: "volume_greater_than_zero",
    MIN_PRESSURE_GREATER_THAN_OR_EQUAL_TO_ZERO: "min_pressure_greater_than_or_equal_to_zero",
    PLEASE_SELECT_MISSING_FIELDS: "please_select_missing_fields",
    ADDING_TO_SYSTEM: "adding_to_system",
    UPDATING_IN_SYSTEM: "updating_in_system",
    DELETING_FROM_SYSTEM: "deleting_from_system",
    DELETE_ACTIVITY_CONFIRMATION: "delete_activity_confirmation",
    DELETE_ACTIVITY_SUCCESS: "delete_activity_success",
    DELETE_ACTIVITY_FAILED: "delete_activity_failed",
  },

  // Form-related text
  FORMS: {
    PLEASE_PROVIDE: "please_provide",
    PLEASE_SELECT: "please_select",
    ENTER: "enter",
    SELECT: "select",
    INFORMATION_BELOW: "information_below",
    HELPER_TEXT_CREATE: "helper_text_create",
    HELPER_TEXT_EDIT: "helper_text_edit",
    HELPER_TEXT_ORDER: "helper_text_order",
    HELPER_TEXT_FULFILLMENT: "helper_text_fulfillment",
    HELPER_TEXT_ACTIVITY: "helper_text_activity",
    PLACEHOLDER_ENTER_NAME: "placeholder_enter_name",
    END_DATE_BEFORE_START: "end_date_before_start",
    INVALID_DATE_FORMAT: "invalid_date_format",
    NOT_APPLICABLE: "not_applicable",
    AT_LEAST_ONE_ASSET: "at_least_one_asset",
    ASSETS_UNAVAILABLE: "assets_unavailable",
    ASSETS_UNAVAILABLE_MESSAGE: "assets_unavailable_message",
  },

  // Field labels
  LABELS: {
    NAME: "label_name",
    TYPE: "label_type",
    VOLUME: "label_volume",
    MIN_PRESSURE: "label_min_pressure",
    START_DATE: "label_start_date",
    END_DATE: "label_end_date",
    CUSTOMER: "label_customer",
    SITE: "label_site",
    ASSET: "label_asset",
    ASSETS: "label_assets",
    ORDER_NAME: "label_order_name",
    SITE_NAME: "label_site_name",
    ASSET_NAME: "label_asset_name",
    FILL_SITE_NAME: "label_fill_site_name",
  },

  // Action verbs (present continuous)
  ACTIONS: {
    CREATING: "creating",
    UPDATING: "updating",
    DELETING: "deleting",
    ARCHIVING: "archiving",
    SCHEDULING: "scheduling",
    STARTING: "starting",
    COMPLETING: "completing",
    BILLING: "billing",
  },

  // Common phrases
  COMMON: {
    ADD_NEW: "add_new",
    TO_THE_SYSTEM: "to_the_system",
    A: "a",
    AN: "an",
    THE: "the",
    OF: "of",
    FOR: "for",
    WITH: "with",
    AND: "and",
  },
} as const

// Type-safe copy mappings for common use cases
export const DEFAULT_COPY_MAPPINGS = {
  [COPY_KEYS.HEADINGS.TIMESTAMP]: "Timestamp",
  [COPY_KEYS.HEADINGS.SITE]: "Customer Site",
  [COPY_KEYS.HEADINGS.CUSTOMER]: "Customer",
  [COPY_KEYS.HEADINGS.ASSET]: "Asset",
  [COPY_KEYS.HEADINGS.LOCATION]: "Current Location",
  [COPY_KEYS.HEADINGS.TYPE]: "Type",
  [COPY_KEYS.HEADINGS.STATUS]: "Status",
  [COPY_KEYS.HEADINGS.NAME]: "Name",
  [COPY_KEYS.HEADINGS.ACTIONS]: "Actions",
  [COPY_KEYS.HEADINGS.USAGE]: "Usage",
  [COPY_KEYS.HEADINGS.AMOUNT]: "Hydrogen amount (kg)",
  [COPY_KEYS.HEADINGS.RUN_DRY]: "Run Dry",
  [COPY_KEYS.HEADINGS.REFUEL_NEEDED]: "Refuel needed in",
  [COPY_KEYS.HEADINGS.TIME_TO_DEPLETION]: "Asset Depleted in",
  [COPY_KEYS.HEADINGS.NOTE]: "Note",
  [COPY_KEYS.HEADINGS.SITES]: "Site(s)",
  [COPY_KEYS.HEADINGS.ASSETS]: "Asset(s)",
  [COPY_KEYS.HEADINGS.ASSET_NAME]: "Asset Name",
  [COPY_KEYS.HEADINGS.CURRENT_ORDER]: "Current Order",
  [COPY_KEYS.HEADINGS.HYDROGEN_ORDERED]: "Hydrogen ordered (kg)",
  [COPY_KEYS.HEADINGS.HYDROGEN_CONSUMED]: "Hydrogen consumed (kg)",
  [COPY_KEYS.HEADINGS.HYDROGEN_RETURNED]: "Hydrogen returned (kg)",
  [COPY_KEYS.HEADINGS.HYDROGEN_RETURNED_PER_FULFILLMENT]: "Hydrogen returned per fulfillment (kg)",
  [COPY_KEYS.HEADINGS.AVERAGE_ORDER]: "Average order (kg)",
  // Orders/Deployments
  [COPY_KEYS.HEADINGS.ORDER]: "Order",
  [COPY_KEYS.HEADINGS.ORDERS]: "Orders",
  [COPY_KEYS.HEADINGS.ORDER_ID]: "Order ID",
  [COPY_KEYS.HEADINGS.ORDER_QUANTITY]: "Ordered Quantity (kg)",
  [COPY_KEYS.HEADINGS.ORDER_START]: "Start",
  [COPY_KEYS.HEADINGS.ORDER_END]: "End",
  [COPY_KEYS.HEADINGS.ACTIVITY]: "Activity",
  [COPY_KEYS.HEADINGS.ACTIVITIES]: "Activities",
  [COPY_KEYS.HEADINGS.ACTIVITY_NAME]: "Activity ID",
  [COPY_KEYS.HEADINGS.ACTIVITY_TYPE]: "Activity Type",
  [COPY_KEYS.HEADINGS.QUANTITY]: "Quantity (kg)",
  [COPY_KEYS.HEADINGS.START_DATE]: "Start Date",
  [COPY_KEYS.HEADINGS.END_DATE]: "End Date",
  [COPY_KEYS.HEADINGS.INFORMATION]: "Information",
  [COPY_KEYS.HEADINGS.DETAILS]: "Details",
  [COPY_KEYS.HEADINGS.SCHEDULED_QUANTITY]: "Scheduled Quantity (kg)",
  [COPY_KEYS.HEADINGS.ACTUAL_QUANTITY]: "Actual Quantity (kg)",
  [COPY_KEYS.HEADINGS.QUANTITY_FULFILLED]: "Planned (kg)",
  [COPY_KEYS.HEADINGS.QUANTITY_CONSUMED]: "Consumed (kg)",
  [COPY_KEYS.HEADINGS.QUANTITY_DELIVERED]: "Delivered (kg)",
  [COPY_KEYS.HEADINGS.QUANTITY_PLANNED]: "Planned (kg)",
  [COPY_KEYS.HEADINGS.QUANTITY_ORDERED]: "Ordered (kg)",
  [COPY_KEYS.HEADINGS.COMPLETED]: "Completed",
  [COPY_KEYS.HEADINGS.SCHEDULED]: "Scheduled",
  [COPY_KEYS.HEADINGS.IN_PROGRESS]: "In Progress",
  [COPY_KEYS.HEADINGS.STATUS_HISTORY]: "Status history",
  [COPY_KEYS.HEADINGS.SOURCE]: "Source",
  [COPY_KEYS.HEADINGS.DESTINATION]: "Destination",
  [COPY_KEYS.HEADINGS.PERFORM_ACTIONS]: "Perform actions associated with this",
  [COPY_KEYS.HEADINGS.EDIT_PREFIX]: "Edit",
  // Calendar
  [COPY_KEYS.HEADINGS.CALENDAR]: "Calendar",
  // Filling
  [COPY_KEYS.HEADINGS.FILL_SITE]: "Fill site",
  [COPY_KEYS.HEADINGS.FILL_SITES]: "Fill sites",
  [COPY_KEYS.HEADINGS.FILL_ACTIVITIES]: "Fill Activities",
  [COPY_KEYS.HEADINGS.FILLS]: "Fills",
  [COPY_KEYS.HEADINGS.SELECT_FILL_SITE]: "Select fill site",
  [COPY_KEYS.HEADINGS.LEVEL]: "Hydrogen Level (kg)",
  // Buttons
  [COPY_KEYS.BUTTONS.CREATE]: "Create",
  [COPY_KEYS.BUTTONS.CREATE_SITE]: "Create Site",
  [COPY_KEYS.BUTTONS.EDIT]: "Edit",
  [COPY_KEYS.BUTTONS.DELETE]: "Delete",
  [COPY_KEYS.BUTTONS.ARCHIVE]: "Delete",
  [COPY_KEYS.BUTTONS.MANAGE]: "Manage",
  [COPY_KEYS.BUTTONS.MANAGE_FULFILMENTS]: "Manage Fulfilments",
  [COPY_KEYS.BUTTONS.SCHEDULE]: "Schedule",
  [COPY_KEYS.BUTTONS.START]: "Start",
  [COPY_KEYS.BUTTONS.COMPLETE]: "Complete",
  [COPY_KEYS.BUTTONS.BILL]: "Bill",
  [COPY_KEYS.BUTTONS.EDIT_DETAILS]: "Edit Details",
  [COPY_KEYS.BUTTONS.EDIT_ID]: "Edit ID",
  [COPY_KEYS.BUTTONS.SAVE]: "Save",
  [COPY_KEYS.BUTTONS.CANCEL]: "Cancel",
  [COPY_KEYS.BUTTONS.COLLAPSE]: "Collapse",
  [COPY_KEYS.BUTTONS.EXPAND]: "Expand",
  [COPY_KEYS.BUTTONS.DELETE_ACTIVITY]: "Delete Activity",
  [COPY_KEYS.BUTTONS.START_ACTIVITY]: "Start Activity",
  [COPY_KEYS.BUTTONS.COMPLETE_ACTIVITY]: "Complete Activity",
  [COPY_KEYS.BUTTONS.EDIT_DATES]: "Edit dates",
  // Messages
  [COPY_KEYS.MESSAGES.CREATED]: "created",
  [COPY_KEYS.MESSAGES.UPDATED]: "updated",
  [COPY_KEYS.MESSAGES.DELETED]: "deleted",
  [COPY_KEYS.MESSAGES.ARCHIVED]: "archived",
  [COPY_KEYS.MESSAGES.STARTED]: "started",
  [COPY_KEYS.MESSAGES.BILLED]: "billed",
  [COPY_KEYS.MESSAGES.FAILED]: "Failed",
  [COPY_KEYS.MESSAGES.SUCCESS]: "Success",
  [COPY_KEYS.MESSAGES.ERROR]: "Error",
  [COPY_KEYS.MESSAGES.LOADING]: "Loading",
  [COPY_KEYS.MESSAGES.SUCCESSFULLY_CREATED]: "has been successfully created",
  [COPY_KEYS.MESSAGES.SUCCESSFULLY_UPDATED]: "has been successfully updated",
  [COPY_KEYS.MESSAGES.SUCCESSFULLY_DELETED]: "has been successfully deleted",
  [COPY_KEYS.MESSAGES.SUCCESSFULLY_ARCHIVED]: "has been successfully archived",
  [COPY_KEYS.MESSAGES.HAS_BEEN_SUCCESSFULLY]: "has been successfully",
  [COPY_KEYS.MESSAGES.CREATION_FAILED]: "Creation Failed",
  [COPY_KEYS.MESSAGES.UPDATE_FAILED]: "Update Failed",
  [COPY_KEYS.MESSAGES.DELETION_FAILED]: "Deletion Failed",
  [COPY_KEYS.MESSAGES.VALIDATION_ERROR]: "Validation Error",
  [COPY_KEYS.MESSAGES.UNEXPECTED_ERROR]: "An unexpected error occurred",
  [COPY_KEYS.MESSAGES.ASSETS_UNAVAILABLE]:
    "asset(s) are not available for the selected dates. Please remove them or change the dates.",
  [COPY_KEYS.MESSAGES.END_DATE_BEFORE_START_DATE]: "End date cannot be before start date",
  [COPY_KEYS.MESSAGES.INVALID_DATE_FORMAT]: "Invalid date format. Please check your dates.",
  [COPY_KEYS.MESSAGES.PLEASE_PROVIDE_NAME]: "Please provide a name for the",
  [COPY_KEYS.MESSAGES.PLEASE_SELECT_TYPE]: "Please select a type for the",
  [COPY_KEYS.MESSAGES.VOLUME_GREATER_THAN_ZERO]: "Volume must be greater than 0",
  [COPY_KEYS.MESSAGES.MIN_PRESSURE_GREATER_THAN_OR_EQUAL_TO_ZERO]:
    "Minimum operating pressure must be greater than or equal to 0",
  [COPY_KEYS.MESSAGES.PLEASE_SELECT_MISSING_FIELDS]: "Please select:",
  [COPY_KEYS.MESSAGES.ADDING_TO_SYSTEM]: "Adding to system...",
  [COPY_KEYS.MESSAGES.UPDATING_IN_SYSTEM]: "Updating in system...",
  [COPY_KEYS.MESSAGES.DELETING_FROM_SYSTEM]: "Deleting from system...",
  [COPY_KEYS.MESSAGES.DELETE_ACTIVITY_CONFIRMATION]:
    "Are you sure you want to delete this activity? This action cannot be undone.",
  [COPY_KEYS.MESSAGES.DELETE_ACTIVITY_SUCCESS]: "Activity deleted successfully",
  [COPY_KEYS.MESSAGES.DELETE_ACTIVITY_FAILED]: "Failed to delete activity",
  // Forms
  [COPY_KEYS.FORMS.PLEASE_PROVIDE]: "Please provide",
  [COPY_KEYS.FORMS.PLEASE_SELECT]: "Please select",
  [COPY_KEYS.FORMS.ENTER]: "Enter",
  [COPY_KEYS.FORMS.SELECT]: "Select",
  [COPY_KEYS.FORMS.INFORMATION_BELOW]: "information below",
  [COPY_KEYS.FORMS.HELPER_TEXT_CREATE]: "Please provide {entity} information below.",
  [COPY_KEYS.FORMS.HELPER_TEXT_EDIT]: "Please update {entity} information below.",
  [COPY_KEYS.FORMS.HELPER_TEXT_ORDER]: "Please provide order information below.",
  [COPY_KEYS.FORMS.HELPER_TEXT_FULFILLMENT]: "Please provide fulfillment information below.",
  [COPY_KEYS.FORMS.HELPER_TEXT_ACTIVITY]: "Please provide activity information below.",
  [COPY_KEYS.FORMS.PLACEHOLDER_ENTER_NAME]: "Enter {entity} name",
  [COPY_KEYS.FORMS.END_DATE_BEFORE_START]: "End date cannot be before start date",
  [COPY_KEYS.FORMS.NOT_APPLICABLE]: "Not applicable",
  [COPY_KEYS.FORMS.AT_LEAST_ONE_ASSET]: "at least one asset",
  [COPY_KEYS.FORMS.ASSETS_UNAVAILABLE_MESSAGE]:
    "asset(s) are not available for the selected dates. Please remove them or change the dates.",
  // Labels
  [COPY_KEYS.LABELS.NAME]: "Name",
  [COPY_KEYS.LABELS.TYPE]: "Type",
  [COPY_KEYS.LABELS.VOLUME]: "Volume (m³)",
  [COPY_KEYS.LABELS.MIN_PRESSURE]: "Minimum Operating Pressure (bar)",
  [COPY_KEYS.LABELS.START_DATE]: "Start Date",
  [COPY_KEYS.LABELS.END_DATE]: "End Date",
  [COPY_KEYS.LABELS.CUSTOMER]: "Customer",
  [COPY_KEYS.LABELS.SITE]: "Site",
  [COPY_KEYS.LABELS.ASSET]: "Asset",
  [COPY_KEYS.LABELS.ASSETS]: "Assets",
  [COPY_KEYS.LABELS.ORDER_NAME]: "Order Name",
  [COPY_KEYS.LABELS.SITE_NAME]: "Site Name",
  [COPY_KEYS.LABELS.ASSET_NAME]: "Asset Name",
  [COPY_KEYS.LABELS.FILL_SITE_NAME]: "Fill Site Name",
  // Actions
  [COPY_KEYS.ACTIONS.CREATING]: "Creating",
  [COPY_KEYS.ACTIONS.UPDATING]: "Updating",
  [COPY_KEYS.ACTIONS.DELETING]: "Deleting",
  [COPY_KEYS.ACTIONS.ARCHIVING]: "Archiving",
  [COPY_KEYS.ACTIONS.SCHEDULING]: "Scheduling",
  [COPY_KEYS.ACTIONS.STARTING]: "Starting",
  [COPY_KEYS.ACTIONS.COMPLETING]: "Completing",
  [COPY_KEYS.ACTIONS.BILLING]: "Billing",
  // Common
  [COPY_KEYS.COMMON.ADD_NEW]: "Add a new",
  [COPY_KEYS.COMMON.TO_THE_SYSTEM]: "to the system",
  [COPY_KEYS.COMMON.A]: "a",
  [COPY_KEYS.COMMON.AN]: "an",
  [COPY_KEYS.COMMON.THE]: "the",
  [COPY_KEYS.COMMON.OF]: "of",
  [COPY_KEYS.COMMON.FOR]: "for",
  [COPY_KEYS.COMMON.WITH]: "with",
  [COPY_KEYS.COMMON.AND]: "and",
} as const

// Helper type for type-safe copy key usage
export type CopyKey = (typeof COPY_KEYS)[keyof typeof COPY_KEYS][keyof (typeof COPY_KEYS)[keyof typeof COPY_KEYS]]
